import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { AdminCosmeticCharacteristicRequest } from './admin-cosmetic-characteristic.request';
import { AdminCosmeticFileRequest } from './admin-cosmetic-file.request';
import { AdminCosmeticStatus } from '../../enums/admin-cosmetic-status';
import { AdminDictionaryProductAttributeRequest } from '@web/shared/module/dictionary';

@jsonObject
export class AdminCosmeticUpdateRequest {
  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly price?: Nillable<string>;

  @jsonMember(String)
  public readonly cosmeticBrandId?: Nillable<Guid>;

  @jsonMember(String)
  public readonly featuredFileId?: Nillable<Guid>;

  @jsonMember(String)
  public readonly warehouseGoodId?: Nillable<Guid>;

  @jsonMember(String)
  public readonly vendorUrl?: Nillable<string>;

  @jsonMember(String)
  public readonly slug?: Nillable<string>;

  @jsonMember(String)
  public readonly status!: AdminCosmeticStatus;

  @jsonArrayMember(AdminDictionaryProductAttributeRequest)
  public readonly attributes?: Nillable<
    AdminDictionaryProductAttributeRequest[]
  >;

  @jsonArrayMember(AdminCosmeticCharacteristicRequest)
  public readonly characteristics?: Nillable<
    AdminCosmeticCharacteristicRequest[]
  >;

  @jsonArrayMember(AdminCosmeticFileRequest)
  public readonly files?: Nillable<AdminCosmeticFileRequest[]>;

  public constructor(
    private readonly data: {
      attributes?: Nillable<AdminDictionaryProductAttributeRequest[]>;
      characteristics?: Nillable<AdminCosmeticCharacteristicRequest[]>;
      cosmeticBrandId?: Nillable<Guid>;
      featuredFileId?: Nillable<Guid>;
      files?: Nillable<AdminCosmeticFileRequest[]>;
      name: string;
      price?: Nillable<string>;
      slug?: Nillable<string>;
      status: AdminCosmeticStatus;
      vendorUrl?: Nillable<string>;
      warehouseGoodId?: Nillable<Guid>;
    },
  ) {
    this.attributes = this.data.attributes;
    this.characteristics = this.data.characteristics;
    this.cosmeticBrandId = this.data.cosmeticBrandId;
    this.featuredFileId = this.data.featuredFileId;
    this.files = this.data.files;
    this.name = this.data.name;
    this.price = this.data.price;
    this.slug = this.data.slug;
    this.status = this.data.status;
    this.vendorUrl = this.data.vendorUrl;
    this.warehouseGoodId = this.data.warehouseGoodId;
  }
}
